export const GET_MMS_SALES_ACTION_TYPE = 'mmsSales/getMmsSales';
export const GET_MMS_SALES_BY_ORDER_ID_ACTION_TYPE = 'mmsSales/getMmsSalesById';

export const LIMIT = { limit: 100, page: 1 };

export const MMS_SALES_PAGE_UI_PROPS = {
  SEARCH: {
    SOURCE_ORDER_ID_PLACEHOLDER: 'Source Order ID',
  },
  COLUMNS: {
    OPERATOR: 'Operator ID',
    MARKET_ID: 'Market Id',
    DEVICE_ID: 'Device Id',
    SOURCE_ORDER_ID: 'Source Order Id',
    NET_TOTAL: 'Net Total',
    GROSS_TOTAL: 'Gross Total',
    ORDER_DTM: 'Order DTM',
    CREATED_ON: 'Created On',
  },
  QUERY_PARAM_FILTER: {
    SELECT_FILTER: 'Select Date Filter',
    DATE_FILTER: 'Date Filter',
  },
};

export const MMS_SALES_EFILTER = [
  {
    queryParam: 'orderDtm',
    name: 'Order Dtm',
  },
  {
    queryParam: 'createdOn',
    name: 'Created On',
  }
];
export const MMS_SALES_ACCORDION_TABS_TITLES = {
  CARD_TITLES: {
    PURCHASED_PRODUCT_DETAILS: 'Purchased Product Details',
    PAYMENT_DETAILS: 'Payment Details',
    PRICE_DETAILS: 'Price Details',
    TAX_DETAILS: 'Order Taxes',
    SALES_FEE_DETAILS: 'Order Fees',
    SALES_TAX_DETAILS: 'Sale Taxes',
  },
  SECTION_TITLES: {
    PRICE_PAYMENT_AND_PURCHASED_PRODUCTS: 'Product Details',
    TAXES_SALES_TAX_AND_SALES_FEE: 'Tax & Fee Details',
    PAYMENT_AND_SUMMARY: 'Payment & Summary',
  },
  SECTION_DESCRIPTION: {
    PRICE_PAYMENT_AND_PURCHASED_PRODUCTS:
      'Price,Payment and Purchased Products details',
    TAXES_SALES_TAX_AND_SALES_FEE: 'Taxes,Sales Tax and Sales Fee details',
  },
  CARD_VALUE_TEXT: {
    PRODUCT_DETAILS: 'pricePaymentAndPurchasedProducts',
    TAX_DETAILS: 'taxAndFee',
  },
  PANEL: {
    HEADER_TITLE: 'Order Detail',
    LABEL_ORDER_ID: 'Order ID',
    LABEL_MARKET_ID: 'Market ID',
    LABEL_UPDATED: 'Updated',
  },
  PRODUCTS_TABLE: {
    COL_NUM: 'Id',
    COL_PRODUCT: 'Product',
    COL_QTY: 'Qty',
    COL_COST: 'Cost',
    COL_PRICE: 'Price',
    COL_BASE: 'Base',
    COL_FEES: '+ Fees',
    COL_TAX: '+ Tax',
    COL_TOTAL: 'Total',
    PRODUCT_ID_PREFIX: 'ID:',
    PRODUCT_CODE_PREFIX: 'Code:',
    FOOTER_ITEM_LABEL: 'item',
  },
  SUMMARY: {
    ORDER_SUMMARY: 'Order Summary',
    PRODUCTS_LABEL: 'Products',
    NET_TOTAL: 'Net Total',
  },
  TAXES_FEES: {
    SECTION_ORDER_TAXES: 'Order Taxes',
    SECTION_ORDER_FEES: 'Order Fees',
    SECTION_PER_PRODUCT: 'Per Product',
    COUNT_LABEL_ITEM: 'item',
    COUNT_LABEL_PRODUCT: 'product',
    TOTAL_TAX: 'Total Tax',
    TOTAL_FEES: 'Total Fees',
  },
};
